module.exports = __webpack_public_path__ + "daebd2a2.jpg";